import {Text as MantineText} from '@mantine/core';

/**
 * Body text — design-layer pass-through over Mantine `Text`.
 * @registry Pass-through Mantine Text; import this instead of @mantine/core outside src/design.
 */
export const Text = MantineText;
